<template>
	<div>
		<span class="board text">+{{ multiple }}</span>
		<svg class="board" x="0px" y="0px" viewBox="0 0 200 300">
			<g>
				<polygon class="st0" points="0,16.13 6.95,291.47 191.93,290.75 200,27.92 193.88,8.53 	" />
				<polygon class="st1" points="5.83,20.9 18.45,287.49 183.8,286.4 193.88,18.18 	" />
				<polygon class="st2" points="30.76,278.21 170.97,279.75 181.81,29.49 23.06,29.32 	" />
				<polygon class="st0" points="30.76,278.21 33.46,277.86 30.4,35.11 170.67,39.53 168.89,279.72 170.97,279.75 181.81,29.49 
		23.06,29.32 	" />
				<polygon class="st3" points="7.44,23.08 16.27,194.83 25.28,191.38 21.22,27.92 	" />
				<polygon class="st3" points="16.36,196.78 17.81,234.51 27,227.17 25.42,194.33 	" />
				<polygon class="st0" points="18.45,287.49 180.6,284.67 190.95,22.94 193.88,18.18 183.8,286.4 	" />
				<polygon class="st0" points="30.76,278.21 23.06,29.32 181.81,29.49 171.12,280.67 184.38,29.32 21.22,27.92 	" />
				<polygon class="st0" points="30.76,278.21 73.99,276.13 78.94,245.48 82.04,271.74 135.6,271.74 137.76,131.44 145.81,273.97 
		170.97,279.75 	" />
			</g>
			<g>
				<path class="st4" d="M100.1,162.28c-30.64,0-55.57-24.93-55.57-55.56s24.93-55.57,55.57-55.57c30.64,0,55.56,24.93,55.56,55.57
		S130.74,162.28,100.1,162.28z M100.1,53.31c-29.45,0-53.41,23.96-53.41,53.41s23.96,53.41,53.41,53.41s53.41-23.96,53.41-53.41
		S129.55,53.31,100.1,53.31z"/>
				<path class="st4" d="M100.1,151.36c-24.61,0-44.64-20.02-44.64-44.64c0-24.61,20.02-44.64,44.64-44.64
		c24.61,0,44.64,20.02,44.64,44.64C144.74,131.33,124.71,151.36,100.1,151.36z M100.1,63.81c-23.66,0-42.91,19.25-42.91,42.9
		s19.25,42.9,42.91,42.9s42.9-19.25,42.9-42.9S123.76,63.81,100.1,63.81z"/>
				<rect x="43.23" y="203.77" class="st4" width="120.74" height="1.73" />
				<rect x="111.78" y="163.01" transform="matrix(5.705825e-03 -1 1 5.705825e-03 -102.323 325.7511)" class="st4"
					width="1.74" height="102.64" />
				<rect x="35.98" y="252.38" transform="matrix(0.9992 -0.0398 0.0398 0.9992 -10.0024 4.1817)" class="st4"
					width="128.03" height="1.74" />
			</g>
		</svg>
	</div>
</template>


<script>
  export default {
	name: 'board',
	props: ['multiple'],
  }
</script>

<style scoped>
.text {
	text-align: center;
	color: #fff;
	z-index: 10;
	top: 17vh !important;
	font-size: 9vh;
}

.board {
	position: fixed;
	width: 35vh;
	top: 5vh;
	left: 26vw;
}

.st0 {
	opacity: 0.3;
	fill: #313131;
}

.st1 {
	fill: #822717;
}

.st2 {
	fill: #005633;
}

.st3 {
	opacity: 0.1;
	fill: #FFFFFF;
}

.st4 {
	fill: #d1d1d1
}
</style>
